import { render, staticRenderFns } from "./RequestCustomerView.vue?vue&type=template&id=d6d8f102&scoped=true&"
import script from "./RequestCustomerView.vue?vue&type=script&lang=js&"
export * from "./RequestCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./RequestCustomerView.vue?vue&type=style&index=0&id=d6d8f102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d8f102",
  null
  
)

export default component.exports